export default __webpack_public_path__ + "static/media/photo--lg--misc-26.0b158456.jpg";